import { render, staticRenderFns } from "./crudPHPInterfaces.vue?vue&type=template&id=421a5e97&"
import script from "./crudPHPInterfaces.vue?vue&type=script&lang=js&"
export * from "./crudPHPInterfaces.vue?vue&type=script&lang=js&"
import style0 from "./crudPHPInterfaces.vue?vue&type=style&index=0&id=421a5e97&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports